import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/Dialog";
import { buildRichAnswerDocument } from "../utils/richAnswerDocument";

type RichAnswerDialogProps = {
  html: string | null
  open: boolean
  onOpenChange: (open: boolean) => void
};

// Le HTML vient de l'équipe Yeati et peut être une page complète avec ses styles et
// ses scripts. Il tourne donc dans une iframe sans allow-same-origin : origine opaque,
// aucun accès au parent ni aux cookies, et son CSS ne fuit pas dans la Console.
const RichAnswerDialog = ({ html, open, onOpenChange }: RichAnswerDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-4xl" hasTitle>
      <DialogHeader>
        <DialogTitle>Réponse détaillée</DialogTitle>
      </DialogHeader>
      {html && (
        <iframe
          title="Réponse détaillée"
          srcDoc={buildRichAnswerDocument(html)}
          sandbox="allow-scripts"
          className="w-full min-h-[60vh] rounded-md border bg-white"
        />
      )}
    </DialogContent>
  </Dialog>
);

export default RichAnswerDialog;
